const LOGIN = '/login'
const ESQUECI_MINHA_SENHA = '/esqueci-minha-senha'
const ALTERAR_SENHA = '/senha/alterar'

const DASHBOARD = '/dashboard'
const PLANOS = '/planos'
const TIPOS_CONSULTAS = '/tiposconsultas'
const CLIENTES = '/clientes'
const USUARIOS = '/usuarios'
const NOTAS_FISCAIS = '/notasfiscais'
const CONSULTAS = '/consultas'
const EU = '/eu'

export {
  ALTERAR_SENHA,
  CLIENTES,
  CONSULTAS,
  DASHBOARD,
  ESQUECI_MINHA_SENHA,
  EU,
  LOGIN,
  NOTAS_FISCAIS,
  PLANOS,
  TIPOS_CONSULTAS,
  USUARIOS,
}
